module.exports = __webpack_public_path__ + "img/progress_019.de7af5bf.png";